<iris-card [elevation]="1">
  <div class="card-contents">
    <h2>Book a session with Dominique</h2>

    <div class="soonest-available">
      <span>Soonest available: Monday June 10</span>
    </div>

    <div class="timezone">
      <p>{{ providerTimeZone | providerTimeZoneString }} timezone displayed</p>
    </div>

    <appointment-carousel></appointment-carousel>

    <div class="session-type" *ngIf="showSessionType">
      <p>I'd prefer a video session</p>
      <p>I'd prefer an in-person session <span>123 Main Street, Denver CO 80236</span></p>
      <p>I don't have a preference</p>
    </div>

    <iris-card-footer>  
      <div class="button-container">
        <iris-button
          [buttonType]="irisButtonTypes.PRIMARY"
        >
          Connect without selecting a time
        </iris-button>
      </div>
     </iris-card-footer>
  </div>
</iris-card>
